import React, { useState } from 'react';
import dynamicfunction from '../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { languages, languageOptions } from '../config/config';
import { changeLanguage, getGeneralClientDetail } from '../store/actions/settingAction';
import { cn } from '../utils/utils';
import { setLanguage } from '../store/slices/contentSlice';
import { useLocation, useNavigate } from 'react-router';
import { getClientData } from '../store/actions/investmentsAction';
import icons from '../constants/icons';
import { ReactSVG } from 'react-svg';
import ViewReverse from './ViewReverse';
import { getUserDetail } from '../store/actions/authActions';
import { setDashboardKey } from '../store/slices/commonSlice';

const Language = ({ isLogin = false }) => {
    const { isArabic, TextWeight } = dynamicfunction();
    const dispatch = useDispatch();
    const location = useLocation();

    const [open, setOpen] = useState(false);

    const { user } = useSelector((state) => state.common);
    const { client_id } = useSelector((state) => state.constant);

    const handleLanguage = (id) => {
        ((client_id && location.pathname === '/corporate-form' || client_id && location.pathname === '/individual-form') || user)
            ? dispatch(
                changeLanguage(id, () => {
                    if (location.pathname !== '/corporate-form' && location.pathname !== '/individual-form' && location.pathname !== '/pending-applications' && location.pathname !== '/' && location.pathname !== '/create-account' && location.pathname !== '/eligible-accounts' && location.pathname !== '/linked-accounts' && location.pathname !== '/set-client-credentials') {
                        dispatch(setDashboardKey());
                        dispatch(getClientData());
                        dispatch(getGeneralClientDetail());
                        dispatch(getUserDetail(user));
                    }
                })
            )
            : dispatch(setLanguage({ language: id == 3 ? languages?.eng : languages?.arb }));
    };

    return (
        <div className='flex items-center gap-2'>
            <div className='relative inline-block text-left'>
                {/* Dropdown Button */}
                <ViewReverse onClick={() => setOpen(!open)} className={cn('flex items-center gap-3 cursor-pointer px-3 py-2 bg-transparent rounded-md', isLogin ? 'text-black' : 'text-white')}>
                    <ReactSVG src={isLogin ? icons.BlackLangeIcon : icons.lange} className='w-6 h-6 flex items-center' />
                    <span className={cn('flex items-center', TextWeight.regular)}>{isArabic ? 'العربية' : 'English'}</span>
                    <ReactSVG src={isLogin ? icons.BlackDownArrowIcon : icons.downArrowWhite} className={'w-4 h-4 flex items-center'} />
                </ViewReverse>

                {/* Dropdown Menu */}
                {open && (
                    <div className={cn('absolute mt-2 w-28 bg-white shadow-lg rounded-md py-2 z-10', isArabic ? 'left-0' : 'right-0')}>
                        {languageOptions?.map((lang) => (
                            <div
                                key={lang?.id}
                                onClick={() => {
                                    handleLanguage(lang?.id);
                                    setOpen(false);
                                }}
                                className={cn(`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100`, (isArabic ? 4 : 3) === lang?.id ? 'opacity-40' : '', TextWeight.regular)}
                            >
                                {lang?.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Language;
